module.exports = __webpack_public_path__ + "img/user.41b87404.png";